import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dental/frontend/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/dental/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CtaSection"] */ "/var/www/dental/frontend/src/components/marketing/home/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/var/www/dental/frontend/src/components/marketing/home/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntroSection"] */ "/var/www/dental/frontend/src/components/marketing/home/IntroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformSection"] */ "/var/www/dental/frontend/src/components/marketing/home/PlatformSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProcessSection"] */ "/var/www/dental/frontend/src/components/marketing/home/ProcessSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Counter"] */ "/var/www/dental/frontend/src/components/marketing/motion/Counter.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/dental/frontend/src/components/marketing/motion/Reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceVisual"] */ "/var/www/dental/frontend/src/components/marketing/services/ServiceVisual.tsx");
